<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon">
          <i class="pe-7s-graph3 icon-gradient bg-wa-dashboard"></i>
        </div>
        <div>
          Dashboard
          <div class="page-title-subheading">Employee headcount, by department and by role.</div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>

  <div *ngIf="isLoading" class="dashboard-loading text-center text-muted py-5">Loading employee data...</div>

  <div
    *ngIf="!isLoading && !errorMessage && departmentGroups.length === 0"
    class="dashboard-empty text-center text-muted py-5"
  >
    No employees found yet.
  </div>

  <div class="row" [hidden]="isLoading || errorMessage || departmentGroups.length === 0">
    <div class="col-12 mb-3">
      <div class="card chart-card h-100">
        <div class="card-header">
          <span class="chart-card__dot chart-card__dot--total"></span>
          Employees by Department
          <span class="chart-card__total">{{ totalEmployees }} total</span>
        </div>
        <div class="card-body">
          <div class="chart-card__canvas" style="height: 340px">
            <canvas #departmentCanvas></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!isLoading && !errorMessage && departmentGroups.length > 0">
    <div class="col-lg-4 col-md-6 col-12 mb-3" *ngFor="let group of departmentGroups; trackBy: trackByDepartment">
      <div class="card chart-card h-100">
        <div class="card-header">
          <span class="chart-card__dot" [style.background]="group.color"></span>
          {{ group.department }}
          <span class="chart-card__total">{{ group.employees.length }}</span>
        </div>
        <div class="card-body">
          <div class="chart-card__canvas" style="height: 240px">
            <canvas #roleCanvas></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
